import { lt } from "./lt";
import { ru } from "./ru";
import type { SiteContent } from "./types";

export type { SiteContent } from "./types";
export type { CommonContent } from "./types";

export const content: Record<string, SiteContent> = { lt, ru };
